import { Button, Collapse, Typography } from 'antd'
import React from 'react'
import { formatCents } from '../../Utilities'
import {
  PANEL_CONTAINER_DIV,
  COLLAPSE_HEADING_DIV,
  SUPPLIER_TYPE_TEXT,
  PANEL_HEADING_DIV,
  ATTACHMENTS_CONTAINER_DIV,
  LINK_BUTTON,
  NUMBER_OF_SUPPLIERS_CONTAINER,
  LEFT_CONTENT_CONTAINER_DIV,
  RIGHT_CONTENT_CONTAINER_DIV,
  FILE_OUTLINED_ICON,
  SUPPLIER_ATTACHMENTS_ICON,
  STYLED_COLLAPSE_CONTAINER_TEMPLATE,
} from './styles'
import { SuppliersSupplierDealFragment } from './Suppliers.generated-types'
import styled from 'styled-components'
import {
  FileOutlined,
  MinusSquareOutlined,
  PaperClipOutlined,
  PlusSquareOutlined,
} from '@ant-design/icons'

const { Text } = Typography

const { Panel } = Collapse

interface SuppliersProps {
  supplierDeals: SuppliersSupplierDealFragment[]
}

const StyledCollapseContainer = styled.div`
  ${STYLED_COLLAPSE_CONTAINER_TEMPLATE}
`

export const Suppliers = ({ supplierDeals }: SuppliersProps): JSX.Element => (
  <div style={PANEL_CONTAINER_DIV}>
    <div style={COLLAPSE_HEADING_DIV}>
      <Text strong>Additional costs</Text>
    </div>
    <StyledCollapseContainer>
      <Collapse
        expandIconPosition='end'
        expandIcon={({ isActive, collapsible }) => {
          if (collapsible === 'disabled') {
            return null
          }

          return isActive ? <MinusSquareOutlined /> : <PlusSquareOutlined />
        }}
        bordered={false}
        ghost>
        {supplierDeals.map((supplierDeal, index) => {
          const disableExpandablePanel: boolean =
            !supplierDeal.attachments.length && !supplierDeal.message && supplierDeal.message !== ''

          // Calculate the last child in what will be rendered so special CSS can apply to it

          let isLastChild: boolean = false

          if (index === supplierDeals.length - 1) {
            isLastChild = true
          }

          return (
            <Panel
              header={
                <div style={PANEL_HEADING_DIV}>
                  <div style={LEFT_CONTENT_CONTAINER_DIV}>
                    <Text strong style={SUPPLIER_TYPE_TEXT}>
                      {supplierDeal.supplier.type}
                    </Text>
                    {supplierDeal.supplier?.name ? <span>{supplierDeal.supplier.name}</span> : null}
                    {supplierDeal.attachments && supplierDeal.attachments.length > 0 ? (
                      <div style={NUMBER_OF_SUPPLIERS_CONTAINER}>
                        <PaperClipOutlined style={SUPPLIER_ATTACHMENTS_ICON} />
                        <Text strong>{supplierDeal.attachments.length}</Text>
                      </div>
                    ) : null}
                  </div>
                  <div style={RIGHT_CONTENT_CONTAINER_DIV}>
                    <Text strong>{formatCents('GBP', supplierDeal.cost)}</Text>
                  </div>
                </div>
              }
              key={index}
              collapsible={disableExpandablePanel ? 'disabled' : null}
              // Used to style the last child differently to all other elements - used in combination with the styled component styles which reference this class
              className={isLastChild ? 'collapse-last-child' : null}>
              {disableExpandablePanel ? null : (
                <>
                  <div>{supplierDeal.message ? `"${supplierDeal.message}"` : null}</div>
                  <div style={ATTACHMENTS_CONTAINER_DIV}>
                    {supplierDeal.attachments?.map((attachment, index) => (
                      <>
                        <FileOutlined style={FILE_OUTLINED_ICON} />
                        <Button
                          key={index}
                          type='link'
                          href={attachment.URL}
                          target='_blank'
                          rel='noopener noreferrer'
                          style={LINK_BUTTON}>
                          {attachment.filename}
                        </Button>
                      </>
                    )) ?? null}
                  </div>
                </>
              )}
            </Panel>
          )
        })}
      </Collapse>
    </StyledCollapseContainer>
  </div>
)
